
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"m19.693 18.086-4.193-6.29V4.25h1.75a.75.75 0 0 0 0-1.5H6.75a.75.75 0 0 0 0 1.5H8.5v7.546l-4.193 6.29a3 3 0 0 0 2.496 4.664h10.394a3 3 0 0 0 2.496-4.664Zm-2.496 3.164H6.803a1.5 1.5 0 0 1-1.248-2.332L10 12.25v-8h4v8l4.445 6.668a1.501 1.501 0 0 1-1.248 2.332Z","fill":"#6D6E6F"}})])
          )
        }
      }
    